import { Component } from '@angular/core';
import { MensIntimateWashComponent } from '@components/consultation-request/upsells/mens-intimate-wash/mens-intimate-wash.component';

@Component({
  selector: 'app-mens-intimate-wash-male-bv',
  imports: [MensIntimateWashComponent],
  templateUrl: './mens-intimate-wash-male-bv.component.html',
})
export class MensIntimateWashMaleBvComponent {}
